import React, { Component } from 'react';
import { $tv } from 'react-tv-focusable';
import { Link } from 'react-router-dom';
import { setCookie, getCookie, delCookie, delLocalStorage } from '../../util/cookie';
import Marquee from '../../components/marquee/marquee';
import { report } from '../../util/dataReporting';
import { keycodeHandle } from '../../util/util';
import { QRCodeSVG } from 'qrcode.react';
import './quitApplication.scss';
import { withTranslation } from 'react-i18next';
import { astroQuitApplication } from '../../request/http';
import { removeNavigations } from '../newHome/getData';
export default withTranslation()(class NewQuitApplication extends Component {
  constructor(props) {
    super(props);
    this.ExitMark = React.createRef();
    this.AgainMark = React.createRef();
    this.codeMark = React.createRef();
    this.loadingcodeMark = React.createRef();
    this.state = {
      codeUrl: '',
      codeFocus: false,
      isEnlarge: false,
      ExitFlag: false, // 退出应用是否获焦
      AgainFlag: false, // 再逛逛是否获焦
      ExitUpdown: false, // 退出应用上下移动画
      ExitAbout: false, // 退出应用左右移动画
      AgainUpdown: false, // 再逛逛上下移动画
      AgainAbout: false, // 再逛逛左右移动画
      isIflix: false,
    };
  }
  componentWillMount() {
    setCookie('page_id', ''); // 当前页面的id
    if (document.domain === 'tv.iflix.com' || document.domain === 'test.iflix.com') {
      this.setState({
        codeUrl:
          'https://qqlivei18n.onelink.me/ETTr?pid=uncolorcloud&type=1&af_force_deeplink=true&af_dp=iflix://iflix.com/hometab?tabname=channel', // iflix
        isIflix: true,
      });
    } else {
      this.setState({
        codeUrl:
          'https://qqlivei18n.onelink.me/ETTr?pid=uncolorcloud&type=1&af_force_deeplink=true&af_dp=tenvideoi18n://wetv/hometab?tabname=channel', // wetv
        isIflix: false,
      });
    }
  }
  componentDidMount() {
    keycodeHandle({ exit: this.quitApplicationKeyDown, quit: this.quitApplicationKeyDown });
    $tv.distanceToCenter = false;
    // 退出应用
    this.ExitMark.current.addEventListener('onFocus', this.ExitFocus.bind(this));
    this.ExitMark.current.addEventListener('onBlur', this.ExitBlur.bind(this));
    this.ExitMark.current.addEventListener('down', this.ExitDown.bind(this));
    this.ExitMark.current.addEventListener('left', this.ExitLeft.bind(this));
    this.ExitMark.current.addEventListener('click', this.ExitClick.bind(this));
    this.ExitMark.current.addEventListener('mouseenter', this.ExitMouseenter.bind(this));
    // 再逛逛
    this.AgainMark.current.addEventListener('onFocus', this.AgainFocus.bind(this));
    this.AgainMark.current.addEventListener('onBlur', this.AgainBlur.bind(this));
    this.AgainMark.current.addEventListener('right', this.AgainRight.bind(this));
    this.AgainMark.current.addEventListener('down', this.AgainDown.bind(this));
    this.AgainMark.current.addEventListener('mouseenter', this.AgainMouseenter.bind(this));
    // 二维码
    this.codeMark.current.addEventListener('onFocus', this.codeFocus.bind(this));
    this.codeMark.current.addEventListener('onBlur', this.codeBlur.bind(this));
    this.codeMark.current.addEventListener('click', this.codeClick.bind(this));
    this.codeMark.current.addEventListener('mouseenter', this.codeMouseenter.bind(this));
    // 放大二维码
    this.loadingcodeMark.current.addEventListener('right', this.loadingcodeRight.bind(this));
    this.loadingcodeMark.current.addEventListener('left', this.loadingcodeleft.bind(this));
    this.loadingcodeMark.current.addEventListener('up', this.loadingcodeup.bind(this));
    this.loadingcodeMark.current.addEventListener('down', this.loadingcodedown.bind(this));
    $tv.requestFocus(this.codeMark.current);
  }
  componentWillUnmount() {
    setCookie('ref_page', ''); // 当前页面的上个页面id
    $tv.distanceToCenter = true;
    this.setState = () => false;
  }
  // 监听esc和Backspace事件
  quitApplicationKeyDown = (e) => {
    e && e.preventDefault && e.preventDefault();
    if (this.state.isEnlarge) {
      this.setState({
        isEnlarge: false,
      });
      $tv.requestFocus(this.codeMark.current);
    } else {
      window.history.back();
    }
  };
  // 二维码鼠标获焦
  codeMouseenter() {
    $tv.requestFocus(this.codeMark.current);
  }
  // 二维码获焦
  codeFocus() {
    this.setState({
      codeFocus: true,
    });
  }
  // 二维码失焦
  codeBlur() {
    this.setState({
      codeFocus: false,
    });
  }
  // 点击二维码放大
  codeClick() {
    this.setState({
      isEnlarge: true,
    });
    $tv.requestFocus(this.loadingcodeMark.current);
  }
  // 放大二维码右移
  loadingcodeRight() {
    $tv.requestFocus(this.loadingcodeMark.current);
  }
  // 放大二维码左移
  loadingcodeleft() {
    $tv.requestFocus(this.loadingcodeMark.current);
  }
  // 放大二维码下移
  loadingcodedown() {
    $tv.requestFocus(this.loadingcodeMark.current);
  }
  // 放大二维码上移
  loadingcodeup() {
    $tv.requestFocus(this.loadingcodeMark.current);
  }
  // 退出应用确认
  ExitClick() {
    if (getCookie('StartTime')) {
      removeNavigations();
      const now = new Date().getTime(); // 获取当前时间时间戳
      const liveTime = now - getCookie('StartTime');
      // 退出应用上报
      report({
        attaId: '0f500063503',
        live_time: liveTime,
      });
      // id末位为3503的多上报到09500070656
      report({
        attaId: '09500070656',
        live_time: liveTime,
      });
    }
    let quitTimer = setTimeout(() => {
      delLocalStorage('isDebugger');
      delCookie('StartTime');
      localStorage.removeItem('navigations');
      const vChannelId = localStorage.getItem('v_channel_id');
      if (vChannelId === '16614') {
        // Astro渠道号为16614;
        astroQuitApplication();
      } else {
        this.closeWebPage();
      }
      clearTimeout(quitTimer);
      quitTimer = null;
    }, 200);
  }
  // 退出应用鼠标获焦
  ExitMouseenter() {
    $tv.requestFocus(this.ExitMark.current);
  }
  // 退出应用获焦
  ExitFocus() {
    this.setState({
      ExitFlag: true,
    });
  }
  // 退出应用失焦
  ExitBlur() {
    this.setState({
      ExitFlag: false,
    });
  }
  // 退出应用下移
  ExitDown() {
    let currentExitUpDown = this.state.ExitUpdown;
    $tv.requestFocus(this.ExitMark.current);
    if (!currentExitUpDown) {
      currentExitUpDown = true;
      this.setState({
        ExitUpdown: currentExitUpDown,
      });
      let ExitUpdownTimer = setTimeout(() => {
        currentExitUpDown = false;
        this.setState({
          ExitUpdown: currentExitUpDown,
        });
        clearTimeout(ExitUpdownTimer);
        ExitUpdownTimer = null;
      }, 1000);
    }
  }
  // 退出应用左移
  ExitLeft() {
    let currentExitAbout = this.state.ExitAbout;
    $tv.requestFocus(this.ExitMark.current);
    if (!currentExitAbout) {
      currentExitAbout = true;
      this.setState({
        ExitAbout: currentExitAbout,
      });
      let ExitAboutTimer = setTimeout(() => {
        currentExitAbout = false;
        this.setState({
          ExitAbout: currentExitAbout,
        });
        clearTimeout(ExitAboutTimer);
        ExitAboutTimer = null;
      }, 1000);
    }
  }
  // 再逛逛鼠标获焦
  AgainMouseenter() {
    $tv.requestFocus(this.AgainMark.current);
  }
  // 再逛逛获焦
  AgainFocus() {
    this.setState({
      AgainFlag: true,
    });
  }
  // 再逛逛失焦
  AgainBlur() {
    this.setState({
      AgainFlag: false,
    });
  }
  // 再逛逛右移
  AgainRight() {
    let currentAgainAbout = this.state.AgainAbout;
    $tv.requestFocus(this.AgainMark.current);
    if (!currentAgainAbout) {
      currentAgainAbout = true;
      this.setState({
        AgainAbout: currentAgainAbout,
      });
      let AgainAboutTimer = setTimeout(() => {
        currentAgainAbout = false;
        this.setState({
          AgainAbout: currentAgainAbout,
        });
        clearTimeout(AgainAboutTimer);
        AgainAboutTimer = null;
      }, 1000);
    }
  }
  // 再逛逛下移
  AgainDown() {
    let currentAgainUpdown = this.state.AgainUpdown;
    $tv.requestFocus(this.AgainMark.current);
    if (!currentAgainUpdown) {
      currentAgainUpdown = true;
      this.setState({
        AgainUpdown: currentAgainUpdown,
      });
      let AgainUpdownTimer = setTimeout(() => {
        currentAgainUpdown = false;
        this.setState({
          AgainUpdown: currentAgainUpdown,
        });
        clearTimeout(AgainUpdownTimer);
        AgainUpdownTimer = null;
      }, 1000);
    }
  }
  // 关闭浏览器
  closeWebPage() {
    if (navigator.userAgent.indexOf('MSIE') > 0) {
      // IE
      if (navigator.userAgent.indexOf('MSIE 6.0') > 0) {
        // IE6
        window.opener = null;
        window.close();
      } else {
        // IE6+
        window.open('', '_top');
        window.top.close();
      }
    } else {
      window.location.href = 'about:blank';
      window.opener = null;
      window.open('', '_self', '');
      window.close();
    }
  }
  render() {
    return (
      <div className="quitWrapper">
        <div className="quit_loading" style={{ display: this.state.isEnlarge ? 'flex' : 'none' }}>
          <div className="quit_loading_code" focusable ref={this.loadingcodeMark}>
            <div className="quit_loading_img">
              {' '}
              <QRCodeSVG className="quit_loading_QRCode" value={this.state.codeUrl} size={350} />
            </div>
            <span className="quit_loading_title">{this.props.t('返回操作回到上级页面')}</span>
          </div>
        </div>
        <div className="quitContainer">
          <div className="quitHeader">{this.props.t('您确认现在退出吗？')}</div>
          <div className="quitHeader1">{this.state.isIflix ? this.props.t('iflix还有可用的手机App，快来下载吧！') : this.props.t('WeTV还有可用的手机App，快来下载吧！')}</div>
          <div className="quitContent">
            <div className="quit_left">
              <span className="quit_title">{this.state.isIflix ? this.props.t('扫描下方二维码下载iflix App') : this.props.t('扫描下方二维码下载WeTV App')}</span>
              <div
                className={[this.state.codeFocus ? 'quit_code_h' : 'quit_code_s'].join(' ')}
                focusable
                ref={this.codeMark}
              >
                <div className="quit_code">
                  {' '}
                  <QRCodeSVG className="quit_QRCode" value={this.state.codeUrl} size={350} />
                </div>
                <span className="quitCode_title">{this.props.t('点击OK键可放大二维码')}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="Exit_div">
          <span
            focusable
            ref={this.ExitMark}
            className={[
              this.state.ExitFlag ? 'Exit_h' : 'Exit_s',
              this.state.ExitUpdown ? 'quitShake' : null,
              this.state.ExitAbout ? 'quitShake1' : null,
            ].join(' ')}
          >
            <Marquee
              children={this.props.t('退出应用')}
              mainWidth={200}
              scrollStatus={this.state.ExitFlag}
              index={0}
            />
          </span>
          <Link to={'/'} style={{ color: 'transparent' }}>
            <span
              focusable
              ref={this.AgainMark}
              className={[
                this.state.AgainFlag ? 'Again_h' : 'Again_s',
                this.state.AgainUpdown ? 'quitShake' : null,
                this.state.AgainAbout ? 'quitShake1' : null,
              ].join(' ')}
            >
              <Marquee
                children={this.props.t('再逛逛')}
                mainWidth={200}
                scrollStatus={this.state.AgainFlag}
                index={1}
              />
            </span>
          </Link>
        </div>
      </div>
    );
  }
});
